<!--
 * @Author: Lemon C
 * @Date: 2024-04-29 14:38:40
 * @LastEditTime: 2025-03-11 17:28:08
-->
<template>
    <div class="sup-docs-scroll-anchor">
        <span class="sdrs-title">文本内容</span>
        <div class="sdrs-tree-box">
            <el-tree
                :data="anchor_list"
                :props="defaultProps"
                :default-expand-all="true"
                :highlight-current="true"
                icon-class="none"
                :expand-on-click-node="false"
                ref="ref_eltree"
                @node-click="tree_node_click"
                node-key="anchorId">
                <template #default="{ data }">
                    <div class="node-sel-content-box">
                        <span class="node-sel-content-box-text">{{ data.name }}</span>
                    </div>
                </template>
            </el-tree>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, onBeforeUnmount, watch, watchEffect, nextTick } from 'vue';
import { useMessageStore } from '@/stores/message';
import { useStateStore } from '@/stores/state';

const state_store = useStateStore();
const message_store = useMessageStore();

const props = defineProps({
    anchor_list: {
        type: Array,
        default: () => [],
    },
    scroll_anchor_callback: Function,
});

const ref_eltree = ref(null);
const defaultProps = ref({
    children: 'children',
    label: 'name',
});

watch(
    () => props.anchor_list,
    () => {
        const firstAnc = props.anchor_list[0];
        if (firstAnc) {
            nextTick(() => {
                ref_eltree.value.setCurrentKey(firstAnc.anchorId);
            });
        }
    }
);

onMounted(() => {
    message_store.addMessageHandler(message_store.M_E_SCROLL_ANCHOR, m_e_scroll_anchor);
});

onBeforeUnmount(() => {
    message_store.removeMessageHandler(message_store.M_E_SCROLL_ANCHOR, m_e_scroll_anchor);
});

// MARK el-tree  节点点击
const tree_node_click = (data, node, el) => {
    state_store.scroll_anchor_click = true;
    props.scroll_anchor_callback(data.anchorId);
};

// MARK el-tree  滚动锚点联动
const m_e_scroll_anchor = (e) => {
    ref_eltree.value.setCurrentKey(e.anchorId);
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-docs-scroll-anchor {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    border-left: 1px solid var(--color-main-doc-segmentation-line-bg);
    padding: 0 30px;
    box-sizing: border-box;

    .sdrs-title {
        position: relative;
        margin-top: 35px;
        margin-bottom: 15px;
        width: 100%;
        height: 27px;
        font-weight: 400;
        font-size: 18px;
        color: var(--color-main-text-primary);
        line-height: 27px;
        box-sizing: border-box;
    }

    :deep(.sdrs-tree-box) {
        display: flex;
        position: relative;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 7px;
        box-sizing: border-box;

        .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
            box-sizing: border-box;
            border-left: 3px solid var(--color-main-brand);
            background: var(--color-main-brand-hover-light);
            border-top-right-radius: 2px;
            border-bottom-right-radius: 2px;

            .node-sel-content-box {
                .node-sel-content-box-text {
                    color: var(--color-main-brand);
                }
            }
        }

        .el-tree {
            position: relative;
            width: 100%;

            .el-tree-node__content {
                height: unset !important;
                box-sizing: border-box;
                border-left: 3px solid var(--color-main-border-gray);

                &:hover {
                    background: var(--color-main-brand-hover-light);
                    border-top-right-radius: 2px;
                    border-bottom-right-radius: 2px;
                }
            }

            .node-sel-content-box {
                position: relative;
                display: flex;
                flex: 1;
                margin: 2px 0;
                padding: 0px 6px;
                box-sizing: border-box;
                width: 100%;
                height: 36px;
                display: flex;
                align-items: center;
                overflow: hidden;

                .node-sel-content-box-text {
                    font-weight: bold;
                    width: 100%;
                    font-size: 16px;
                    color: var(--color-main-text-primary);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .el-tree-node__children {
                .node-sel-content-box {
                    .node-sel-content-box-text {
                        font-weight: 500;
                    }
                }
            }
        }
    }
}
</style>
